import { defineComponent as _defineComponent } from 'vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetBaseComponent',
  props: {
  loadedData: {
    type: Boolean,
    default: true
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  customClass: {
    type: String,
    default: ''
  },
  showHeader: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props;



const calculateMainHeight = () => {
  setTimeout(() => {
    const el = document.querySelector('.widget-base-component') as HTMLElement
    if (!el) return

    const height = el.clientHeight
    const elementWithScroll = el.querySelector('.element-with-scroll') as HTMLElement

    if (elementWithScroll) {
      elementWithScroll.style.height = `${height - 120}px`
    }
  })
}

return { __sfc: true,props, calculateMainHeight, SpinnerLayerComponent }
}

})